import { PlannedService } from "app/models/plannedService";

export class PlannedServicesShortListFilterOptions {
  public isFinishedInTimeStatus: PlannedServicesShortListFilterOptions.IsFinishedInTimeStatus;
}

export namespace PlannedServicesShortListFilterOptions {

  export enum IsFinishedInTimeStatus {
    Expired,
    FinishedInTime
  }
}



// WEBPACK FOOTER //
// /app/SPA/src/app/dto/plannedServicesShortListFilterOptions.ts